<template>
  <div class="bg">
    <div class="login-form">
      <el-card :body-style="{ padding: '20px 40px 100px 40px'}" style="border-radius: 50px">
        <el-form class="form" :model="form" ref="form" :rules="rules" label-width="80px">
          <h1 style="margin-bottom: 60px;font-size: 40px">学员登录</h1>
          <el-form-item prop="username" label="账号" label-width="30%">
            <el-input class="loginform-input" v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="密码" label-width="30%" style="margin: 40px 0">
            <el-input class="loginform-input" v-model="form.password" show-password></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-button type="primary" @click="login">登 录</el-button>
            </el-col>
          </el-row>
        </el-form>
        
      </el-card>
    </div>
    
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  data() {
    var usernameValidate = (rule, value, callback)=>{
      if (!value || value == '') {
        return callback(new Error('请输入学生账号'))
      } else {
        return callback();
      }
    };
    var passwordValidate = (rule, value, callback)=>{
      if (!value || value == '') {
        return callback(new Error('请输入密码'))
      } else {
        return callback();
      }
    };
    return {
      loginApi: 'permission/open/login',
      reviewApi: 'review/review-word/',
      form: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          { validator: usernameValidate, trigger: 'blur' }
        ],
        password: [
          { validator: passwordValidate, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    ...mapMutations([
      'setInfo'
    ]),
    login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$fly.post(this.loginApi,this.form).then((res)=>{
            let userInfo = res;
            userInfo.school = userInfo.school.replace(/\/r/g,'').replace(/\/n/g,'')
            if (userInfo.id) {
              this.setInfo(userInfo);
              // this.$fly.post(`${this.reviewApi}${userInfo.id}`).then((res)=>{
              //   if(res.length >= 4) {
              //     this.jumpToReview(res);
              //   } else {
              //     this.jumpToHome();
              //   }
              // })
              this.jumpToHome();
            }
          })
        } else {
          return false;
        }
      });
      
    },
    jumpToHome() {
      this.$router.push('/')
    },
    jumpToReview(words) {      
      let date = new Date()
      this.$router.push({
        name: '练习',
        params: {
          'name': `每日复习 ${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`,
          'type': 1,
          'questionCount': 300,
          'words': [words],
        }
      })
    }
  }
}
</script>

<style scoped>
.bg{
  width: 100v;
  height: 100vh;
  background-size: 120% 125%;
  background-image: url('../../assets/login-bg.png');
  background-position-x: 60%;
  background-position-y: 15%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.switch-text{
  color: #334970ee;
  font-size: 1.2em;
  margin: 30px 0;
}
.login-form{
  min-width: 500px;
  width: 30%;
  margin: auto;
  padding: 120px 0 0 0;
}
.loginform-input >>> .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 40px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #000;
    display: inline-block;
    font-size: 26px;
    height: 50px;
    line-height: 40px;
    outline: 0;
    padding: 0px 15px;
    width: 100%;
}
.el-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #334970ee;
    border: 1px solid #DCDFE6;
    color: #FFF;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    /* padding: 22px 160px; */
    width: 70%;
    font-size: 32px;
    border-radius: 40px;
}
.el-button--primary:focus, .el-button--primary:hover {
    background: #334970ee;
    border-color: #334970ee;
    color: #FFF;
}
.form >>> .el-form-item__label {
    text-align: center;
    float: left;
    font-size: 34px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
}
</style>

